{
  "Clear search": "Vymazať vyhľadávanie"
}